import React from "react";
import styled from "styled-components";
import { centsToCurrencyString } from "../../../utils/numbers";
import { getCandybarTransactionModifiersArray } from "../../../utils/candybar";

const Item = styled.div`
    margin-bottom: 2em;

    &:last-child { margin-bottom: 0; }
`;

const ItemHead = styled.p`
    margin: 0 0 1em;

    &:last-child { margin-bottom: 0; }
`;

const ItemName = styled.span`
    font-weight: 700;
`;

const Configs = styled.p`
    font-size: 0.83em;
    margin: 0;
`;

function ConfirmationCandybarInfo({data}) {
    if (!data || !data.summary || !data.summary.length) {
        return null;
    }

    return <div className="confirmation-info-block">
        {data.summary.map((item, index) => {
            const modifiers = getCandybarTransactionModifiersArray(item.configs);
            return <Item key={index}>
                <ItemHead className="confirmation-info-row">
                    <ItemName>{item.name}</ItemName>
                    {item.price ? centsToCurrencyString(item.price) : ''}
                </ItemHead>
                {modifiers.length > 0 && <Configs>
                    {modifiers.map((modifier, i) => <React.Fragment key={i}>
                        {modifier}<br/>
                    </React.Fragment>)}
                </Configs>}
            </Item>;
        })}
    </div>;
}

export default ConfirmationCandybarInfo;